import alt from 'components/Dispatcher';
import OpportunitySource from 'sources/OpportunitySource';
import OpportunityActions from 'actions/OpportunityActions';

export class OpportunityStore {
  constructor() {
    this.state = {
      opportunity: {isSignUp: false, hasConfirmed: false},
      opportunityList: [],
      registers: [],
      selecters: [],
      id: null,
      first: 0,
      maxCount: 20,
      accessToken: null,
      loading: true,
      hasMore: true,
      offset: 0,
      registersLoading: true,
      registersHasMore: true,
      selectersLoading: true,
      selectersHasMore: true
    };
    this.registerAsync(OpportunitySource);
    this.bindListeners({
      handleFetchOpportunity: OpportunityActions.FETCH_OPPORTUNITY,
      handleUpdateOpportunity: OpportunityActions.UPDATE_OPPORTUNITY,
      handleUpdateOpportunityList: OpportunityActions.UPDATE_OPPORTUNITY_LIST,
      handleUpdateAllOpportunityList: OpportunityActions.UPDATE_ALL_OPPORTUNITY_LIST,
      handleFetchOpportunityList: OpportunityActions.FETCH_OPPORTUNITY_LIST,
      handleSetLoading: OpportunityActions.SET_LOADING,
      handleFetchOpportunityRegister: OpportunityActions.FETCH_OPPORTUNITY_REGISTER,
      handleUpdateOpportunityRegister: OpportunityActions.UPDATE_OPPORTUNITY_REGISTER,
      handleFetchOpportunitySelecter: OpportunityActions.FETCH_OPPORTUNITY_SELECTER,
      handleUpdateOpportunitySelecter: OpportunityActions.UPDATE_OPPORTUNITY_SELECTER,
      handleClearOpportunityRegister: OpportunityActions.CLEAR_OPPORTUNITY_REGISTER,
      handleClearOpportunitySelecter: OpportunityActions.CLEAR_OPPORTUNITY_SELECTER,
      handleSetRegistersLoading: OpportunityActions.SET_REGISTERS_LOADING,
      handleSetSelectersLoading: OpportunityActions.SET_SELECTERS_LOADING,
      handleUpdateOpportunityOffset: OpportunityActions.UPDATE_OPPORTUNITY_OFFSET,
      handleClearOpportunity: OpportunityActions.CLEAR_OPPORTUNITY
    });
  }
  // 设置 loading 状态
  handleSetLoading(loading) {
    this.setState({loading: loading});
  }
  // 根据 Opportunity_id 获取 Media 详情
  handleFetchOpportunity(id) {
    this.state.id = id;
    this.getInstance().getRemoteOpportunity();
  }
  handleClearOpportunity() {
    this.setState({opportunity:{}});
  }
  handleUpdateOpportunityOffset(offset){
    this.setState({offset:offset});
  }
  handleFetchOpportunityRegister(id) {
    let first = this.state.registers.length ? this.state.registers.length + 1 : 0;
    this.setState({id:id,first:first});
    this.getInstance().getRemoteOpportunityRegister();
  }
  handleUpdateOpportunityRegister(registers) {
    let more = registers.length === this.state.maxCount;
    let list = this.state.registers.concat(registers);
    this.setState({registers: list, registersLoading: false, registersHasMore: more});
  }
  handleClearOpportunityRegister(){
    this.setState({registers:[]});
  }
  handleSetRegistersLoading(registersLoading){
    this.setState({registersLoading:registersLoading});
  }
  handleFetchOpportunitySelecter(id) {
    let first = this.state.selecters.length ? this.state.selecters.length + 1 : 0;
    this.setState({id:id,first:first});
    this.getInstance().getRemoteOpportunitySelecter();
  }
  handleUpdateOpportunitySelecter(selecters) {
    let more = selecters.length === this.state.maxCount;
    let list = this.state.selecters.concat(selecters);
    this.setState({selecters: list, selectersLoading: false, selectersHasMore: more});
  }
  handleSetSelectersLoading(selectersLoading){
    this.setState({selectersLoading:selectersLoading});
  }
  handleClearOpportunitySelecter(){
    this.setState({selecters:[]});
  }
  // 保存 Opportunity 详情
  handleUpdateOpportunity(opportunity) {
    this.state.opportunity = opportunity;
  }
  // 发请求追加 OpportunityList
  handleFetchOpportunityList() {
    let first = this.state.opportunityList.length ? this.state.opportunityList.length + 1 : 0;
    this.setState({first: first, loading: true});
    this.getInstance().getRemoteOpportunityList();
  }
  // 追加 OpportunityList 新的数据
  handleUpdateOpportunityList(opportunityList) {
    let more = opportunityList.length === this.state.maxCount;
    let list = this.state.opportunityList.concat(opportunityList);
    this.setState({opportunityList: list, loading: false, hasMore: more});
  }
  // 更新全部 OpportunityList
  handleUpdateAllOpportunityList(opportunityList) {
    this.setState({opportunityList: opportunityList});
  }
}

export default alt.createStore(OpportunityStore, 'OpportunityStore');


// WEBPACK FOOTER //
// ./src/stores/OpportunityStore.js